import { render, staticRenderFns } from "./FileTypeActivity.vue?vue&type=template&id=06c9dbc3&"
import script from "./FileTypeActivity.vue?vue&type=script&lang=js&"
export * from "./FileTypeActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports